import App from './App';
import Main from './main/containers/Main';
import NotFound from './errors/containers/NotFound';
import ThankYou from './pages/containers/ThankYou';

import { fittersLocatorRoutes } from './fitters-locator/routes';
import { profileRoutes } from './profile/routes';
import { signupRoutes } from './sign-up/routes';
import { signinRoutes } from './sign-in/routes';
import { billingRoutes } from './billing/routes';
import { pagesRoutes } from './pages/routes';
import { forgotPassword } from './sign-in/routes';

export const routes = {
    path: '/',
    component: App,
    indexRoute: { component: Main },
    childRoutes: [
        fittersLocatorRoutes,
        signinRoutes,
        signupRoutes,
        pagesRoutes,
        profileRoutes,
        billingRoutes,
        forgotPassword,
        { path: '/process-success', component: ThankYou },
        { path: '*', component: NotFound }
    ]
}


// WEBPACK FOOTER //
// ./src/Routes.js